import React from 'react';
import { motion } from 'framer-motion';
export function Team() {
  const team = [{
    name: 'Isolde Maren',
    role: 'Founder & Chief Strategist',
    bio: '12 years in iGaming SEO, former Head of Growth at major European sportsbook'
  }, {
    name: 'Fenwick Calloway',
    role: 'Head of iGaming SEO',
    bio: 'Technical SEO specialist with focus on regulated gambling markets'
  }, {
    name: 'Sable Dimitriou',
    role: 'Affiliate Operations Director',
    bio: 'Built and scaled affiliate programs generating €50M+ in annual revenue'
  }, {
    name: 'Rune Halversen',
    role: 'Data & Analytics Lead',
    bio: 'Former quantitative analyst, now tracking player LTV and campaign performance'
  }];
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('');
  };
  return <section id="team" className="py-20 felt-texture" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-175">
            The <span className="text-[#00ff88]" data-id="element-176">Operators</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-177">
            Expert strategists who live and breathe sports betting marketing
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#0d2818]/60 border border-[#00ff88]/20 rounded-lg p-6 hover:border-[#00ff88]/50 transition-all hover:glow-green" data-id="element-179">
              <div className="w-20 h-20 bg-gradient-to-br from-[#00ff88] to-[#22c55e] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-180">
                <span className="text-[#0a1a0f] font-bold text-xl" data-id="element-181">
                  {getInitials(member.name)}
                </span>
              </div>
              <h3 className="text-lg font-bold text-center mb-1" data-id="element-182">
                {member.name}
              </h3>
              <div className="text-[#00ff88] text-sm text-center mb-3 font-mono" data-id="element-183">
                {member.role}
              </div>
              <p className="text-gray-400 text-sm text-center" data-id="element-184">{member.bio}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}